(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SatoriAddressReview',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.satori-review button.process-all').click(function processAll(e) {
			e.preventDefault();

			if ($(this).hasClass('disabled')) {
				return;
			}

			Adzuki.CustomConfirm({
				body   : 'You are choosing to process ALL suggested address changes.<br>THIS PROCESS CANNOT BE UNDONE.<br>Are you sure you want to continue?',
				confirm: function _processAll() {
					$('input[name="form_component_data[SatoriAddressReview][process_all]"]').prop('checked', true);
					$form.submit();
				}
			});
		});
	};
}(jQuery, window.Adzuki || {}));
